/**
 * 格式化日期为 YYYY-MM-DD 格式
 * @param {Date|string} date - 日期对象或日期字符串
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(date) {
  if (!date) return ''
  
  // 如果是字符串，转换为日期对象
  const dateObj = typeof date === 'string' ? new Date(date) : date
  
  // 获取年月日
  const year = dateObj.getFullYear()
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')
  
  return `${year}-${month}-${day}`
}

/**
 * 获取当前日期的字符串形式
 * @returns {string} YYYY-MM-DD 格式的当前日期
 */
export function getCurrentDate() {
  return formatDate(new Date())
} 